module.exports = __webpack_public_path__ + "img/LOGOSGPF256Prancheta 5.be8101ca.png";